import React, { FC } from 'react';
import { createPortal } from 'react-dom';
import { TDropdownChoice } from '../../../types/index.types';
import DropdownMenu from './dropdown';

const DropdownChoice: FC<TDropdownChoice> = (props): JSX.Element | null => {
  const { fixedColumn, colHeadings, colOrdInIndex, columnIndex, setColOrdInIndex, setDropdownAtColumnIndex, dropdownPlaceholder } = props;

  if (fixedColumn) {
    return (
      <DropdownMenu
        colHeadings={colHeadings}
        colOrdInIndex={colOrdInIndex}
        columnIndex={columnIndex}
        setColOrdInIndex={setColOrdInIndex}
        setDropdownAtColumnIndex={setDropdownAtColumnIndex}
        fixedDropdown={false}
      />
    );
  }
  if (dropdownPlaceholder) {
    return createPortal(
      <DropdownMenu
        colHeadings={colHeadings}
        colOrdInIndex={colOrdInIndex}
        columnIndex={columnIndex}
        setColOrdInIndex={setColOrdInIndex}
        setDropdownAtColumnIndex={setDropdownAtColumnIndex}
        fixedDropdown={true}
      />,
      dropdownPlaceholder
    );
  }
  return null;
};

export default React.memo(DropdownChoice);
